import { gql } from '@apollo/client';

export const ALL_HIGHEST_QUALIFICATIONS = gql`
  query AllHighestQualifications {
    highestQualifications: getHighestQualifications {
      id
      name
    }
  }
`;
